module.exports = __webpack_public_path__ + "static/media/STPLong1w522@1x.449ff783.jpg";